import { CalendarDrawerContent, ImageDetails } from "burde";
import { D3Selection } from "./draw-calendar";
import { Page } from "svg/constants";
import { getImageUrlByCalendarSize } from "svg/helpers";

export const drawBorder = (
    svg: D3Selection,
    frameColor: string | null,
    page: Page,
    calendarSize: string,
    drawFull: boolean,
    calendarDrawerContent: CalendarDrawerContent,
) => {
    if (svg.select(".borderAnchor").size() == 0) return;

    const borderHeight = svg.select(".borderAnchor").attr("data-height");
    const borderWidth = svg.select(".borderAnchor").attr("data-width");

    if (
        calendarDrawerContent.borderImage &&
        calendarDrawerContent.borderImage.endpoints
    ) {
        const endpoints =
            page == Page.Odd
                ? calendarDrawerContent.borderImage.endpoints.leftPage
                : calendarDrawerContent.borderImage.endpoints.rightPage;

        if (endpoints === undefined) {
            return;
        }

        const endpoint = getImageUrlByCalendarSize(
            endpoints,
            drawFull ? calendarSize : "preview",
        );

        svg.select(".borderAnchor")
            .append("svg:image")
            .attr("x", 0)
            .attr("y", 0)
            .attr("width", borderWidth)
            .attr("height", borderHeight)
            .attr("xlink:href", endpoint)
            .lower();
    } else {
        const color = frameColor ? frameColor : "#FFFFFF";

        svg.select(".borderAnchor")
            .append("rect")
            .attr("x", 0)
            .attr("y", 0)
            .attr("width", borderWidth)
            .attr("height", borderHeight)
            .attr("fill", color)
            .lower();
    }
};
